import { apiSlice } from "../../app/api/apiSlice";

export const extendLockApiSlice = apiSlice.injectEndpoints({
	endpoints: (builder) => ({
		extendLock: builder.mutation({
			query: (credentials) => ({
				url: "/api/v1/loan/lock_extend_request/",
				method: "POST",
				body: credentials?.formData,
			}),
		}),
	}),
});

export const { useExtendLockMutation } = extendLockApiSlice;
